// extracted by mini-css-extract-plugin
export default {"bannerbox":"Banner_bannerbox__X+68q","bannerItem":"Banner_bannerItem__LBx-m"};